import { render, staticRenderFns } from "./invoicesVendors.vue?vue&type=template&id=7799b324&"
import script from "./invoicesVendors.vue?vue&type=script&lang=js&"
export * from "./invoicesVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports